export default __webpack_public_path__ + "static/media/132.d12b154c.jpg";